import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IBulkImportTmdbResponse } from './bulk-import-tmdb-response';
import { bulkImportTmdbResponseSchema } from './bulk-import-tmdb-response';

export interface IBulkImportTmdbParams {
  afterId?: number;
  limit?: number;
}

export async function bulkImportTmdbApi(
  params: IBulkImportTmdbParams = {},
): Promise<IValidatedResponse<IBulkImportTmdbResponse>> {
  const query = new URLSearchParams();
  if (params.afterId !== undefined) {
    query.set('afterId', String(params.afterId));
  }
  if (params.limit !== undefined) {
    query.set('limit', String(params.limit));
  }
  const suffix = query.toString();
  return postRequest<IBulkImportTmdbResponse>({
    path: `/sys/people/v1/import/tmdb/bulk${suffix ? `?${suffix}` : ''}`,
    schema: bulkImportTmdbResponseSchema,
  });
}
